import React, { useState } from 'react';
import { Navigation } from './components/Navigation';
import { Dashboard } from './components/Dashboard';
import { ProductDatabase } from './components/ProductDatabase';
import { MaterialsManagement } from './components/MaterialsManagement';
import { ProductionPlanning } from './components/ProductionPlanning';
import { TrackingSystem } from './components/TrackingSystem';
import { Traceability } from './components/Traceability';
import { BTraceExport } from './components/BTraceExport';
import { UserManagement } from './components/UserManagement';
import { PasswordProtection } from './components/PasswordProtection';
export function App() {
  const [activeView, setActiveView] = useState('dashboard');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const renderActiveView = () => {
    switch (activeView) {
      case 'dashboard':
        return <Dashboard data-id="element-0" />;
      case 'products':
        return <ProductDatabase data-id="element-1" />;
      case 'materials':
        return <MaterialsManagement data-id="element-2" />;
      case 'planning':
        return <ProductionPlanning data-id="element-3" />;
      case 'tracking':
        return <TrackingSystem data-id="element-4" />;
      case 'traceability':
        return <Traceability data-id="element-5" />;
      case 'btrace':
        return <BTraceExport data-id="element-6" />;
      case 'users':
        return <UserManagement data-id="element-7" />;
      default:
        return <Dashboard data-id="element-8" />;
    }
  };
  if (!isAuthenticated) {
    return <PasswordProtection onVerify={() => setIsAuthenticated(true)} data-id="element-9" />;
  }
  return <div className="flex h-screen w-full bg-gray-100" data-id="element-10">
      <Navigation activeView={activeView} setActiveView={setActiveView} data-id="element-11" />
      <main className="flex-1 overflow-auto" data-id="element-12">{renderActiveView()}</main>
    </div>;
}